"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));
/* eslint-disable max-len */


var LogoVisaBlue = function LogoVisaBlue() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "36",
    height: "11",
    viewBox: "0 0 36 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.6821 10.8138L14.5028 0.162109H17.4192L15.5951 10.8138H12.6821Z",
    fill: "#1434CB"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M26.1649 0.448276C25.5893 0.231034 24.6841 0 23.5536 0C20.6753 0 18.6466 1.44483 18.6258 3.51724C18.6084 5.04828 20.0753 5.90345 21.1781 6.41034C22.3121 6.93103 22.6936 7.26552 22.6901 7.73103C22.6832 8.44483 21.785 8.77241 20.9458 8.77241C19.7806 8.77241 19.1598 8.61034 18.2027 8.21379L17.8282 8.04483L17.4189 10.431C18.0986 10.7276 19.3575 10.9862 20.6649 11C23.7305 11 25.7176 9.57241 25.7384 7.35862C25.7488 6.14828 24.972 5.22414 23.2935 4.46552C22.274 3.97241 21.6498 3.64483 21.6567 3.14483C21.6567 2.70345 22.1838 2.22759 23.3247 2.22759C24.2784 2.21379 24.9685 2.42069 25.506 2.63448L25.7696 2.75862L26.1649 0.448276Z",
    fill: "#1434CB"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M33.6386 0.155273H31.388C30.6909 0.155273 30.1673 0.344928 29.8621 1.03803L25.5342 10.8035H28.5963C28.5963 10.8035 29.0957 9.48975 29.2101 9.20355C29.543 9.20355 32.5185 9.207 32.9416 9.207C33.0283 9.57941 33.2953 10.8035 33.2953 10.8035H36.0002L33.6386 0.155273ZM30.0459 7.02079C30.2886 6.407 31.2076 4.04148 31.2076 4.04148C31.1903 4.06907 31.4469 3.42424 31.5926 3.02424L31.7902 3.94493C31.7902 3.94493 32.3486 6.48975 32.4665 7.02079H30.0459Z",
    fill: "#1434CB"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.2372 0.175842L7.3831 7.44136L7.07793 5.9655L6.05838 1.06895C5.88151 0.393083 5.37174 0.193083 4.73712 0.168945H0.0346787L0 0.389635C1.1444 0.665497 2.16395 1.06205 3.06213 1.5586L5.65264 10.8138L8.73557 10.8103L13.3236 0.175842H10.2372Z",
    fill: "#1434CB"
  }));
};

var _default = LogoVisaBlue;
exports.default = _default;